export const reportsData = {
  summary: {
    total_interactions: 12850,
    average_response_time: "1m 18s",
    customer_satisfaction: 4.6,
    first_contact_resolution: 81.5,
    date_range: {
      from: "2023-05-01",
      to: "2023-10-31",
    },
  },
  channel_performance: [
    {
      month: "May",
      voice: 140,
      chat: 85,
      email: 110,
    },
    {
      month: "June",
      voice: 160,
      chat: 92,
      email: 130,
    },
    {
      month: "July",
      voice: 175,
      chat: 102,
      email: 145,
    },
    {
      month: "August",
      voice: 190,
      chat: 118,
      email: 152,
    },
    {
      month: "September",
      voice: 210,
      chat: 140,
      email: 160,
    },
    {
      month: "October",
      voice: 240,
      chat: 165,
      email: 190,
    },
  ],
  kpi_metrics: {
    average_handle_time: "3m 45s",
    queue_time: "51s",
    abandonment_rate: "4.7%",
    service_level: "94.2%",
  },
  agent_performance: [
    {
      name: "Meena R.",
      role: "Team Lead",
      interactions: 423,
      avg_handle_time: "3m 20s",
      csat: 4.8,
      quality_score: "96%",
    },
    {
      name: "Arun Ch.",
      role: "Agent",
      interactions: 380,
      avg_handle_time: "3m 50s",
      csat: 4.6,
      quality_score: "94%",
    },
    {
      name: "Sonali D.",
      role: "Agent",
      interactions: 362,
      avg_handle_time: "4m 15s",
      csat: 4.5,
      quality_score: "91%",
    },
    {
      name: "Rakesh K.",
      role: "Agent",
      interactions: 345,
      avg_handle_time: "3m 05s",
      csat: 4.7,
      quality_score: "92%",
    },
    {
      name: "Neha P.",
      role: "Agent",
      interactions: 338,
      avg_handle_time: "4m 30s",
      csat: 4.4,
      quality_score: "90%",
    },
  ],
};

// Generate summary cards data from the JSON
export const generateSummaryCards = () => [
  {
    title: "Total Interactions",
    value: reportsData.summary.total_interactions.toLocaleString(),
    subtitle: "Calls, chats, and emails",
    change: "+12.5%",
    isPositive: true,
    icon: "📞",
  },
  {
    title: "Average Response Time",
    value: reportsData.summary.average_response_time,
    subtitle: "Across all channels",
    change: "-4.2%",
    isPositive: true,
    icon: "⏱️",
  },
  {
    title: "Customer Satisfaction",
    value: `${reportsData.summary.customer_satisfaction}/5.0`,
    subtitle: "Based on 2,156 ratings",
    change: "-2.1%",
    isPositive: false,
    icon: "😊",
  },
  {
    title: "First Contact Resolution",
    value: `${reportsData.summary.first_contact_resolution}%`,
    subtitle: "Issues resolved first time",
    change: "+3.8%",
    isPositive: true,
    icon: "✅",
  },
];

// Generate KPI metrics cards
export const generateKPICards = () => [
  {
    title: "Average Handle Time",
    value: reportsData.kpi_metrics.average_handle_time,
    change: "8%",
    changeType: "increase",
    changeText: "from last month",
  },
  {
    title: "Queue Time",
    value: reportsData.kpi_metrics.queue_time,
    change: "2%",
    changeType: "decrease",
    changeText: "from last month",
  },
  {
    title: "Abandonment Rate",
    value: reportsData.kpi_metrics.abandonment_rate,
    change: "3%",
    changeType: "increase",
    changeText: "from last month",
  },
  {
    title: "Service Level",
    value: reportsData.kpi_metrics.service_level,
    change: "2",
    changeType: "new",
    changeText: "new this month",
  },
];
